import { render, staticRenderFns } from "./CreateActivityDialog.vue?vue&type=template&id=5394c0e0&scoped=true&"
import script from "@/views/RosterTemplates/CreateActivityDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/RosterTemplates/CreateActivityDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/RosterTemplates/create-activity-dialog.scss?vue&type=style&index=0&id=5394c0e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5394c0e0",
  null
  
)

export default component.exports